export default __webpack_public_path__ + "static/media/TANK_symbol-Klaytn.f3c740af.svg";